import React from 'react';
import './header.css';

const Header = () => {
    return (
        <div>
        </div>
    );
}

export default Header;



// WEBPACK FOOTER //
// ./src/classes/header/Header.js